import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import './App.css';
import axios from 'axios';
import { toast } from 'react-toastify';
import { FaWhatsapp, FaEnvelope, FaPhoneVolume } from 'react-icons/fa';
import { format, parseISO } from 'date-fns';
import { useSelector } from 'react-redux';
import ReactModal from 'react-modal-resizable-draggable';
import api from '~/services/api';
import history from '~/services/history';

// Importando componente
import Card from '~/components/Card';
import Input from '~/components/Form/Input';
import Button from '~/components/Form/Button';
import ButtonGeneral from '~/components/ButtonGeneral';
import Select from '~/components/Form/Select';
import Textarea from '~/components/Form/Textarea';
import Load from '~/components/Load';
import HistoricoObs from './HistoricoObs';

import {
  Container,
  Wrapper,
  Label,
  Combo,
  DS,
  Pergunta,
  Organizador,
  Historico,
  Drag,
  DragBTN,
  ModalBody,
  ModalMenus,
} from './styles';

export default function AtendimentoNew({ match }) {
  const user = useSelector(state => state.user.profile);
  const leadRef = useRef(null);
  const tentativaRef = useRef(null);
  const reativarRef = useRef(null);
  const agendarVisitaRef = useRef(null);
  const enviarNegociacaoRef = useRef(null);
  const enviarLeadRef = useRef(null);
  const agendarRef = useRef(null);
  const cancelarRef = useRef(null);
  const emailRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [carregar, setCarregar] = useState(false);
  const [dadosAtendimento, setDadosAtendimento] = useState([]);
  const [dadosLead, setDadosLead] = useState([]);
  const [instrucaoFormatado, setInstrucaoFormatado] = useState([]);
  const [dadosProduto, setDadosProduto] = useState([]);
  const [perguntas, setPerguntas] = useState([]);
  const [dadosHistorico, setDadosHistorico] = useState([]);
  const [visibleAtendimentoAtivo, setVisibleAtendimentoAtivo] = useState(false);
  const [visibleTentativa, setVisibleTentativa] = useState(false);
  const [visibleReativar, setVisibleReativar] = useState(false);
  const [integracao, setIntegracao] = useState([]);
  const [corretores, setCorretores] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [crmHorario, setCrmHorario] = useState(new Date());
  const [visibleCancelar, setVisibleCancelar] = useState(false);
  const [visibleAgendar, setVisibleAgendar] = useState(false);
  const [cancelamentos, setCancelamentos] = useState([]);
  const [visibleEnviarParaEmail, setVisibleEnviarParaEmail] = useState(false);
  const [visibleLigacao, setVisibleLigacao] = useState(false);
  const [dadosTentativa, setDadosTentativa] = useState({});
  const [sdrResponsavel, setSdrResponsavel] = useState({});
  // Enviar para o crm
  const [visibleAgendarVisita, setVisibleAgendarVisita] = useState(false);
  const [visibleEnviarNegociacao, setVisibleEnviarNegociacao] = useState(false);
  const [visibleEnviarLead, setVisibleEnviarLead] = useState(false);
  const [url, setUrl] = useState('');
  const [assunto, setAssunto] = useState('');

  const getDados = useCallback(async () => {
    setLoading(true);
    const { id } = match.params;

    const responseAtendimento = await api.get(`/atendimentos/${id}`);

    const instrucao = responseAtendimento.data.tentativa.instrucao.replace(
      /\[(USUARIO)\]/g,
      user.name
    );

    // Pegando o historico
    const responseHistorico = await api.get(
      `/atendimento/${responseAtendimento.data.id}/historicos`
    );

    const dataFormatadaHistorico = responseHistorico.data.map(historico => {
      if (typeof historico.created_at === 'string') {
        return {
          ...historico,
          dataFormatada: format(
            parseISO(historico.created_at),
            'dd/MM/yyyy HH:mm:ss'
          ),
        };
      }
      return {
        ...historico,
        dataFormatada: format(historico.created_at, 'dd/MM/yyyy HH:mm:ss'),
      };
    });

    // Pegandos os cancelamentos
    // const responseCancelamento =
    //   responseAtendimento.data.atendimento.lead.produto.incorporadora
    //     .cancelamentos;

    // const dataTemplateCancelamento = responseCancelamento.map(cancelamento => {
    //   return {
    //     value: cancelamento.id,
    //     label: cancelamento.name,
    //   };
    // });

    // Verificando se possui assunto
    if (responseAtendimento.data.tentativa.assunto) {
      const assunto = responseAtendimento.data.tentativa.assunto.replace(
        /\[(USUARIO)\]/g,
        user.name
      );
      setAssunto(assunto);
    }

    setInstrucaoFormatado(instrucao);
    setDadosAtendimento(responseAtendimento.data);
    setSdrResponsavel(responseAtendimento.data.sdr_responsavel);
    setDadosLead(responseAtendimento.data.lead);
    setDadosTentativa(responseAtendimento.data.tentativa);
    setDadosProduto(responseAtendimento.data.produto);
    setPerguntas(responseAtendimento.data.perguntas);

    // console.log(responseAtendimento.data.perguntas)

    setCancelamentos(responseAtendimento.data.cancelamentos);
    setDadosHistorico(dataFormatadaHistorico);
    setIntegracao(responseAtendimento.data.integracao);

    setVisibleAtendimentoAtivo(
      !!(
        responseAtendimento.data.status === '1' ||
        responseAtendimento.data.status === '2'
      )
    );
    setLoading(false);
  }, [match.params, user.name]);

  useEffect(() => {
    getDados();
  }, [getDados]);

  /**
   * Listagem de corretores e produtos
   */

  const getCorretores = useCallback(async () => {
    const responseCorretores = await api.post('/corretores', {
      parametro: integracao.url_corretores,
      cidade: dadosProduto.cidade,
    });

    const dataTemplateCorretores = responseCorretores.data.map(corretor => {
      return {
        value: corretor.id,
        label: corretor.nome,
      };
    });

    setCorretores(dataTemplateCorretores);
  }, [dadosProduto, integracao.url_corretores]);

  const getProdutos = useCallback(async () => {
    let responseProdutos;

    if (user.time.incorporadora_id === 2) {
      responseProdutos = await api.post('/produtos-realiza', {
        parametro: integracao.url_produtos,
        cidade: dadosProduto.cidade,
      });
    } else {
      responseProdutos = await api.post('get-produtos-integromat', {
        url_produtos: integracao.url_produtos,
      });
    }

    // OLD
    // if(user.time.id === 14) {
    //   // console.log('ENTREI')
    //   responseProdutos = await api.get('/produtos-vega')
    // } else if (user.time.id === 16) {
    //   responseProdutos = await api.get('/produtos-six')
    //   console.log(integracao)
    // } else {
    //   responseProdutos = await api.post('/produtos-realiza', {
    //     parametro: integracao.url_produtos,
    //     cidade: dadosProduto.cidade,
    //   });
    // }

    // console.log(responseProdutos.data)

    const dataTemplateCorretores = responseProdutos.data.map(corretor => {
      return {
        value: corretor.id,
        label: corretor.nome,
      };
    });

    setProdutos(dataTemplateCorretores);
  }, [
    dadosProduto.cidade,
    integracao.url_produtos,
    user.time.incorporadora_id,
  ]);

  /**
   * Templates para selects estaticos
   */

  const acaoTemplateAtivos = [
    {
      value: 1,
      label: 'Salvar Tentativa',
    },
    {
      value: 2,
      label: 'Enviar visita para corretor',
    },
    {
      value: 3,
      label: 'Agendar nova tentativa',
    },
    {
      value: 4,
      label: 'Cancelar atendimento',
    },
    {
      value: 5,
      label: 'Enviar negociação para Corretor',
    },
    {
      value: 6,
      label: 'Contato invalido',
    },
    // {
    //   value: 7,
    //   label: 'Enviar lead',
    // },
  ];

  const acaoTemplateInativo = [
    {
      value: 1996,
      label: 'Reativar atendimento',
    },
  ];

  /**
   * Funções do sistema
   */

  // EDITAR LEAD
  async function handleEditarLead(data) {
    try {
      setCarregar(true);
      leadRef.current.setErrors({});

      const schema = Yup.object().shape({
        name: Yup.string().required('Preencha o campo nome'),
        email: Yup.string().required('Preencha o campo email'),
        telefone: Yup.string()
          .required('Preencha o campo telefone')
          .min(10, 'Minimo de 10 caracteres')
          .max(11, 'Maximo de 11 caracteres'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/leads/${dadosLead.id}`, {
        name: data.name,
        email: data.email,
        telefone: data.telefone,
        // canal: dadosLead.canal,
      });

      toast.success('Lead editado com sucesso');
    } catch (err) {
      setCarregar(true);
      toast.error('Error ao editar, verifique os dados');
    } finally {
      setCarregar(false);
    }
  }

  // RESPOSTA QUALIFICAÇÃO
  async function handleChangerResposta(respostaId, perguntaId) {
    // if (respostaId === '-1') {
    //   toast.success('Resposta cadastrada com sucesso');
    //   return
    // }
    try {
      const perguntasTemp = perguntas;

      perguntasTemp.map(pergunta => {
        if (pergunta.id === perguntaId) {
          pergunta.alternativas.map(alternativa => {
            if (alternativa.id == respostaId) {
              pergunta.respostaInformada = [
                [
                  {
                    id: alternativa.id,
                    pergunta_id: pergunta.id,
                    resposta: alternativa.resposta,
                  },
                ],
              ];
            }
          });
        }
      });

      setPerguntas(perguntasTemp);

      await api.post(`/pergunta/${perguntaId}/resposta`, {
        alternativa_id: respostaId,
        lead_id: dadosLead.id,
      });

      toast.success('Resposta cadastrada com sucesso');
    } catch (error) {
      toast.error('Erro ao cadastrar sua resposta, tente novamente.');
    }
  }

  async function handleAcao(idAcao) {
    /**
     * 1 - Salvar tentativa
     * 2 - Agendar visita
     * 3 - Agendar novo atendimento
     * 4 - Cancelar
     * 5 - Enviar negociação para Corretor
     * 6 - Contato Invalido
     * 7 - Enviar lead
     * 1996 - Reativar atendimento
     */
    if (idAcao === 1) {
      setVisibleTentativa(true);
      setVisibleReativar(false);
      setVisibleAgendar(false);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(false);
    } else if (idAcao === 1996) {
      setVisibleTentativa(false);
      setVisibleReativar(true);
      setVisibleAgendar(false);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(false);
    } else if (idAcao === 2) {
      // Agendar visita
      setVisibleTentativa(false);
      setVisibleReativar(false);
      setVisibleAgendar(false);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(true);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(false);
      if (integracao.url_corretores !== null && integracao.url_produtos) {
        if (user.time.corretores === '1' || dadosLead.produto_id === 69) {
          getCorretores();
        }
        if (!dadosAtendimento.unique_product) {
          getProdutos();
        }
      }
    } else if (idAcao === 3) {
      setVisibleTentativa(false);
      setVisibleReativar(false);
      setVisibleAgendar(true);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(false);
    } else if (idAcao === 4) {
      setVisibleTentativa(false);
      setVisibleReativar(false);
      setVisibleAgendar(false);
      setVisibleCancelar(true);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(false);
    } else if (idAcao === 5) {
      // Enviar negociacao para corretor
      setVisibleTentativa(false);
      setVisibleReativar(false);
      setVisibleAgendar(false);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(true);
      setVisibleEnviarLead(false);
      if (integracao.url_corretores !== null && integracao.url_produtos) {
        if (user.time.corretores === '1' || dadosLead.produto_id === 69) {
          getCorretores();
        }
        if (!dadosAtendimento.unique_product) {
          getProdutos();
        }
      }
    } else if (idAcao === 6) {
      setVisibleTentativa(false);
      setVisibleReativar(false);
      setVisibleAgendar(false);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(true);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(false);
    } else if (idAcao === 7) {
      // Enviar Lead
      setVisibleTentativa(false);
      setVisibleReativar(false);
      setVisibleAgendar(false);
      setVisibleCancelar(false);
      setVisibleEnviarParaEmail(false);
      setVisibleAgendarVisita(false);
      setVisibleEnviarNegociacao(false);
      setVisibleEnviarLead(true);
      if (integracao.url_corretores !== null && integracao.url_produtos) {
        if (user.time.corretores === '1' || dadosLead.produto_id === 69) {
          getCorretores();
        }
        if (!dadosAtendimento.unique_product) {
          getProdutos();
        }
      }
    }
  }

  async function handleSalvarTentativa(data, { reset }) {
    try {
      setCarregar(true);
      tentativaRef.current.setErrors({});

      const schema = Yup.object().shape({
        obs: Yup.string().required('Preencha o campo observação'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      const [ tentativa ] = dadosAtendimento?.tentativas.filter(item => {
        return item.tentativa === dadosAtendimento?.tentativa.tentativa + 1
      })

      if (tentativa?.tipo === 'E-mail' && dadosAtendimento.incorporadora.automatic_email) {
        let instrucao = tentativa.instrucao.replace(
          /\[(USUARIO)\]/g,
          user.name
        );

        instrucao = tentativa.instrucao.replace(
          /\[(CLIENTE)\]/g,
          dadosLead.name
        );

        await api.post('message-queue', {
          queue: dadosAtendimento.incorporadora.name,
          routingKey: `${dadosAtendimento.incorporadora.slug}.email`,
          delay: (tentativa.tempo * 60 * 1000),
          data: {
            atendimentoId: dadosAtendimento.id,
            incorporadoraId: dadosAtendimento.incorporadora.id,
            message: {
              user,
              subject: tentativa.assunto,
              body: instrucao,
              to: dadosLead.email
            }
          }                                                               
        })
      }

      await api.put(`/atendimentos/${dadosAtendimento.id}`, {
        tentativa: Number(dadosAtendimento.tentativa.tentativa) + 1,
        obs: data.obs,
      });

      toast.success('Nova tentativa salva com sucesso ');
      setVisibleTentativa(false);
      getDados();
      reset();
      history.push('/atendimento');
    } catch (err) {
      console.log(err)
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        tentativaRef.current.setErrors(validationErrors);
      } else {
        toast.error(
          'Error ao salvar tentativa, tentativas da cadencia finalizadas'
        );
        setVisibleTentativa(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleReativarAtendimento(data, { reset }) {
    try {
      setCarregar(true);
      reativarRef.current.setErrors({});

      const schema = Yup.object().shape({
        obs: Yup.string().required('Preencha o campo observação'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.put(`/atendimento/${dadosAtendimento.id}/reativar`, {
        obs: data.obs,
      });

      toast.success('Atendimento reativado com sucesso ');
      setVisibleReativar(false);
      getDados();
      reset();
      history.push('/atendimento');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        reativarRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao reativar o atendimento, tente novamente.');
        setVisibleReativar(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  // Funcoes de envio para crm

  async function handleAgendarVisita(data, { reset }) {
    try {
      setCarregar(true);
      agendarVisitaRef.current.setErrors({});

      // let schema;

      // if (
      //   (user.time.corretores === '1' && integracao.url_corretores) ||
      //   dadosLead.produto_id === 69
      // ) {

      //   schema = Yup.object().shape({
      //     corretor_id: Yup.string('Selecione um corretor').required(
      //       'Selecione um corretor'
      //     ),
      //     imovel_id: Yup.string('Selecione um imovel').required(
      //       'Selecione um imovel'
      //     ),
      //     obs: Yup.string().required('Preencha o campo observação'),
      //   });
      // } else if (integracao.url_produtos) {
      //   console.log('AQUIIIIi')
      //   // schema = Yup.object().shape({
      //   //   imovel_id: Yup.string('Selecione um imovel').required(
      //   //     'Selecione um imovel'
      //   //   ),
      //   //   obs: Yup.string().required('Preencha o campo observação'),
      //   // });
      // } else {
      //   schema = Yup.object().shape({
      //     obs: Yup.string().required('Preencha o campo observação'),
      //   });
      // }

      // await schema.validate(data, {
      //   abortEarly: false,
      // });

      const responseData = await api.post(
        `/atendimentos/${dadosAtendimento.id}`,
        {
          nameop: 'Agendar Visita',
          corretor_id:
            user.time.corretores === '1' || dadosLead.produto_id === 69
              ? data.corretor_id
              : null,
          imovel_id: data.imovel_id,
          sdr_responsavel: {
            id: dadosAtendimento.sdr_responsavel.id,
            nome: dadosAtendimento.sdr_responsavel.name,
          },
          obs: data.obs,
          horario_visita: data.horario_visita,
        }
      );

      const integracaoData = {
        acao: 'agendamento',
        nome: dadosLead.name,
        email: dadosLead.email,
        telefone: dadosLead.telefone,
        sdr_responsavel: {
          id: dadosAtendimento.sdr_responsavel.id,
          nome: dadosAtendimento.sdr_responsavel.name,
        },
        dt_agendamento: format(crmHorario, 'yyyy-MM-dd HH:mm'),
        observacao: data.obs,
        perguntas,
        motivo_cancelamento: '',
        produto_nome: dadosAtendimento.produto.nome,
        imovel: produtos.find(x => x.value === data.imovel_id),
      }

      if (dadosAtendimento.unique_product || user.time.id === 16) {
          await axios.post(integracao.url, integracaoData);
        }

      if (responseData.data.error) {
        toast.error(responseData.data.error);
      } else {
        toast.success('Agendamento de visita realizado com sucesso ');
        setVisibleAgendarVisita(false);
        getDados();
        reset();
      }
      history.push('/atendimento');
    } catch (err) {
      console.log(err);
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        agendarVisitaRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao agendar visita, tente novamente.');
        setVisibleAgendarVisita(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleEnviarNegociacao(data, { reset }) {
    try {
      setCarregar(true);
      enviarNegociacaoRef.current.setErrors({});

      let schema;

      if (
        (user.time.corretores === '1' && integracao.url_corretores) ||
        dadosLead.produto_id === 69
      ) {
        schema = Yup.object().shape({
          corretor_id: Yup.string('Selecione um corretor').required(
            'Selecione um corretor'
          ),
          imovel_id: Yup.string('Selecione um imovel').required(
            'Selecione um imovel'
          ),
          obs: Yup.string().required('Preencha o campo observação'),
        });
      } else if (integracao.url_produtos) {
        schema = Yup.object().shape({
          // imovel_id: Yup.string('Selecione um imovel').required(
          //   'Selecione um imovel'
          // ),
          obs: Yup.string().required('Preencha o campo observação'),
        });
      } else {
        schema = Yup.object().shape({
          obs: Yup.string().required('Preencha o campo observação'),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      const responseData = await api.post(
        `/atendimentos/${dadosAtendimento.id}`,
        {
          nameop: 'Enviar Negociacao',
          corretor_id: user.time.corretores === '1' ? data.corretor_id : null,
          imovel_id: data.imovel_id,
          obs: data.obs,
          sdr_responsavel: {
            id: dadosAtendimento.sdr_responsavel.id,
            nome: dadosAtendimento.sdr_responsavel.name,
          },
        }
      );

      const integracaoData = {
        acao: 'enviar-negociacao',
        nome: dadosLead.name,
        email: dadosLead.email,
        telefone: dadosLead.telefone,
        sdr_responsavel: {
          id: dadosAtendimento.sdr_responsavel.id,
          nome: dadosAtendimento.sdr_responsavel.name,
        },
        dt_agendamento: format(crmHorario, 'yyyy-MM-dd HH:mm'),
        observacao: data.obs,
        perguntas,
        motivo_cancelamento: '',
        produto_nome: dadosAtendimento.produto.nome,
        imovel: produtos.find(x => x.value === data.imovel_id),
      };

      if (dadosAtendimento.unique_product || user.time.id === 16) {
        await axios.post(integracao.url, integracaoData);
      }

      if (responseData.data.error) {
        toast.error(responseData.data.error);
      } else {
        toast.success('Enviado negociação para o corretor com sucesso ');
        setVisibleEnviarNegociacao(false);
        getDados();
        reset();
      }
      history.push('/atendimento');
    } catch (err) {
      console.log(err);
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        enviarNegociacaoRef.current.setErrors(validationErrors);
      } else {
        toast.error('Erro ao enviar ao enviar negociação, tente novamente.');
        setVisibleEnviarNegociacao(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleEnviarLead(data, { reset }) {
    try {
      setCarregar(true);
      enviarLeadRef.current.setErrors({});

      let schema;
      if (
        (user.time.corretores === '1' && integracao.url_corretores) ||
        dadosLead.produto_id === 69
      ) {
        schema = Yup.object().shape({
          corretor_id: Yup.string('Selecione um corretor').required(
            'Selecione um corretor'
          ),
          imovel_id: Yup.string('Selecione um imovel').required(
            'Selecione um imovel'
          ),
          obs: Yup.string().required('Preencha o campo observação'),
        });
      } else if (integracao.url_produtos) {
        schema = Yup.object().shape({
          imovel_id: Yup.string('Selecione um imovel').required(
            'Selecione um imovel'
          ),
          obs: Yup.string().required('Preencha o campo observação'),
        });
      } else {
        schema = Yup.object().shape({
          obs: Yup.string().required('Preencha o campo observação'),
        });
      }

      await schema.validate(data, {
        abortEarly: false,
      });

      const responseData = await api.post(
        `/atendimentos/${dadosAtendimento.id}`,
        {
          nameop: 'Enviar Lead',
          corretor_id: user.time.corretores === '1' ? data.corretor_id : null,
          imovel_id: data.imovel_id,
          obs: data.obs,
        }
      );

      if (responseData.data.error) {
        toast.error(responseData.data.error);
      } else {
        toast.success('Lead enviado com sucesso ');
        setVisibleEnviarLead(false);
        getDados();
        reset();
      }
      history.push('/atendimento');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        enviarLeadRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao enviar lead, tente novamente.');
        setVisibleEnviarLead(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  // Fim das funcoes

  async function handleAgendarAtendimento(data, { reset }) {
    try {
      setCarregar(true);
      agendarRef.current.setErrors({});

      const schema = Yup.object().shape({
        obs: Yup.string().required('Preencha o campo observação'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/atendimento/${dadosAtendimento.id}/agendar`, {
        horario_atendimento: crmHorario,
        obs: data.obs,
      });
      toast.success('Atendimento agendado com sucesso ');
      setVisibleAgendar(false);
      getDados();
      reset();
      history.push('/atendimento');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        agendarRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao agendar o atendimento, tente novamente.');
        setVisibleAgendar(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleCancelarAtendimento(data, { reset }) {
    try {
      setCarregar(true);
      cancelarRef.current.setErrors({});

      const schema = Yup.object().shape({
        cancelamento_id: Yup.string(
          'Selecione o motivo do cancelamento.'
        ).required('Selecione o motivo do cancelamento'),
        obs: Yup.string().required('Preencha o campo observação'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/atendimentos/${dadosAtendimento.id}/cancelar`, {
        cancelamento_id: data.cancelamento_id,
        obs: data.obs,
      });

      const integracaoData = {
        acao: 'Cancelamento',
        nome: dadosLead.name,
        email: dadosLead.email,
        observacao: data.obs,
        perguntas,
        motivo_cancelamento: cancelamentos.filter(item => {
          return item.id === data.cancelamento_id;
        })[0].name,
        imovel: produtos.find(x => x.value === data.imovel_id),
      };

      // console.log(integracaoData)

      if (dadosAtendimento.unique_product || user.time.id === 16) {
        await axios.post(integracao.url, integracaoData);
      }

      toast.success('Atendimento agendado com sucesso ');
      setVisibleCancelar(false);
      getDados();
      reset();
      history.push('/atendimento');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        cancelarRef.current.setErrors(validationErrors);
      } else {
        toast.error('Error ao agendar o atendimento, tente novamente.');
        setVisibleCancelar(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleEnviarDiretoParaEmail(data, { reset }) {
    try {
      setCarregar(true);
      emailRef.current.setErrors({});

      const schema = Yup.object().shape({
        obs: Yup.string().required('Preencha o campo observação'),
      });

      await schema.validate(data, {
        abortEarly: false,
      });

      await api.post(`/atendimento/${dadosAtendimento.id}/direto-email`, {
        obs: data.obs,
      });

      toast.success(
        'Atendimento enviado direto para tentativa de e-mail com sucesso '
      );
      setVisibleEnviarParaEmail(false);
      getDados();
      reset();
      history.push('/atendimento');
    } catch (err) {
      setCarregar(true);
      const validationErrors = {};
      if (err instanceof Yup.ValidationError) {
        err.inner.forEach(error => {
          validationErrors[error.path] = error.message;
        });
        emailRef.current.setErrors(validationErrors);
      } else {
        toast.error(
          'Error ao envair o atendimento para tentativa e-mail, tente novamente.'
        );
        setVisibleEnviarParaEmail(false);
        getDados();
        reset();
      }
    } finally {
      setCarregar(false);
    }
  }

  async function handleLigacao() {
    try {
      const { id } = match.params;
      const response = await api.post('/voice', {
        id,
        telefone: dadosLead.telefone,
      });
      setUrl(response.data);
      setVisibleLigacao(true);
    } catch (error) {
      toast.error('Token inexistente ou invalido');
    }
  }

  function handlerEnviarEmail() {
    history.push(`/email-atendimento/${dadosAtendimento.id}`, {
      dados: instrucaoFormatado,
      email: dadosLead.email,
      name: dadosLead.name,
      assunto,
    });
  }

  function handleWhatsapp() {

    const link = `https://api.whatsapp.com/send?phone=55${dadosLead.telefone}`;
    const win = window.open(link, '_blank');
    win.focus();
  }

  if (loading) {
    return <Load />;
  }

  return (
    <>
      <Container>
        <Drag>
          <div>
            <h4>Atendimento</h4>
          </div>
          <DragBTN>
            <button type="button" onClick={handlerEnviarEmail}>
              Enviar E-mail
            </button>
            <button type="button" onClick={handleLigacao}>
              Fazer ligaçao
            </button>
            <button type="button" onClick={handleWhatsapp}>
              Whatsapp
            </button>
          </DragBTN>
        </Drag>
        <Wrapper>
          {/* DADOS LEAD - AJUSTADO */}
          <Card size={50}>
            <>
              <h4>Dados do Leads</h4>
              <hr />
              <Form
                ref={leadRef}
                initialData={dadosLead}
                onSubmit={handleEditarLead}
                autoComplete="off"
              >
                <Input icon="MdPerson" label="Nome" name="name" type="text" />
                <Input icon="MdMail" label="E-mail" name="email" type="text" />
                <Input
                  icon="MdPhone"
                  label="Telefone"
                  name="telefone"
                  type="number"
                />
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                  }}
                >
                  <Button tamanho="40px" load={carregar}>
                    Editar
                  </Button>
                  {dadosLead.id !== null && (
                    <a
                      href={`https://app.rdstation.com.br/leads/${dadosLead.id_lead_rd}`}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <ButtonGeneral
                        type="button"
                        tamanho="40px"
                        load={carregar}
                      >
                        Link lead RD
                      </ButtonGeneral>
                    </a>
                  )}
                </div>

                <div style={{ position: 'relative', top: '50px' }}>
                  <h4>SDR responsável pelo lead: {sdrResponsavel.name}</h4>
                </div>
              </Form>
            </>
          </Card>
          {/* INSTRUÇÕES - AJUSTADO */}
          {dadosTentativa && (
            <Card size={50}>
              {dadosTentativa.tipo === 'E-mail' && (
                <h4>
                  <FaEnvelope size={24} color="#FFF" /> Instruções para o
                  atendimento da {dadosTentativa.tentativa} tentativa
                </h4>
              )}
              {dadosTentativa.tipo === 'Telefone' && (
                <h4>
                  <FaPhoneVolume size={24} color="#FFF" /> Instruções para o
                  atendimento da {dadosTentativa.tentativa} tentativa
                </h4>
              )}
              {dadosTentativa.tipo === 'Whatsapp' && (
                <h4>
                  <FaWhatsapp size={24} color="#FFF" /> Instruções para o
                  atendimento da {dadosTentativa.tentativa} tentativa
                </h4>
              )}
              <hr />
              <Label>
                <textarea
                  disabled
                  name="description"
                  type="text"
                  value={instrucaoFormatado}
                />
              </Label>
            </Card>
          )}
        </Wrapper>
        <Wrapper>
          {/* DECRICAO IMOVEL - AJUSTADO */}
          {dadosProduto && (
            <Card size={50}>
              <h4>{`Descriçao do imovel: ${dadosProduto.nome}`}</h4>
              <hr />
              <Label>
                <textarea
                  disabled
                  name="produtoDescription"
                  type="text"
                  value={dadosProduto.descricao}
                />
              </Label>
            </Card>
          )}
          {/* QUALIFICACAO - AJUSTADO */}
          {perguntas && (
            <Card size={50}>
              <h4>Qualificaçao</h4>
              <hr />
              <Form onSubmit={() => {}} autoComplete="off">
                <Combo>
                  {perguntas.map(pergunta => (
                    <Pergunta key={pergunta.id}>
                      <strong>{pergunta.pergunta}</strong>
                      <select
                        name="resp"
                        onChange={e =>
                          handleChangerResposta(e.target.value, pergunta.id)
                        }
                      >
                        {pergunta?.respostaInformada.length > 0 ? (
                          <option>
                            {pergunta?.respostaInformada[0][0]?.resposta}
                          </option>
                        ) : (
                          <option value={-1}>Selecionar resposta</option>
                        )}
                        {pergunta.alternativas
                          .map(alternativa => {
                            return (
                              <option
                                key={alternativa.id}
                                value={alternativa.id}
                              >
                                {alternativa.resposta}
                              </option>
                            );
                          })
                          .filter(Boolean)}
                      </select>
                    </Pergunta>
                  ))}
                </Combo>
              </Form>
            </Card>
          )}
        </Wrapper>
        <Wrapper>
          <Card size={50}>
            <h4>Historico</h4>
            <hr />
            <Organizador>
              {dadosHistorico.map(hist => (
                <Historico key={hist.id}>
                  <b />
                  <div>
                    <time>{hist.dataFormatada}</time>
                    {hist.user_id && <h4>{hist.user.name}</h4>}
                    <h3>
                      Motivo: <span>{hist.acao}</span>
                    </h3>
                    {!!hist.obs && <HistoricoObs obs={hist.obs} />}
                    {hist.url_chamada && (
                      // eslint-disable-next-line jsx-a11y/media-has-caption
                      <>
                        <span>Telefonema: {hist.status_chamada}</span>
                        <br />
                        <audio src={hist.url_chamada} controls>
                          Seu navegador não é suportado
                        </audio>
                      </>
                    )}
                  </div>
                </Historico>
              ))}
            </Organizador>
          </Card>
          <Card size={50}>
            <h4>Atendimento</h4>
            <hr />
            <br />
            <br />
            <Form>
              <Select
                options={
                  visibleAtendimentoAtivo
                    ? acaoTemplateAtivos
                    : acaoTemplateInativo
                }
                labelSelect="Selecione a ação"
                name="acao"
                onChange={text => handleAcao(text.value)}
              />
            </Form>
            {visibleTentativa && (
              <Form
                ref={tentativaRef}
                onSubmit={handleSalvarTentativa}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                <Button tamanho="40px" load={carregar}>
                  Salvar
                </Button>
              </Form>
            )}
            {visibleReativar && (
              <Form
                ref={reativarRef}
                onSubmit={handleReativarAtendimento}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                <Button tamanho="40px" load={carregar}>
                  Salvar
                </Button>
              </Form>
            )}
            {visibleAgendarVisita && (
              <Form
                ref={agendarVisitaRef}
                onSubmit={handleAgendarVisita}
                autoComplete="off"
              >
                <Label>
                  <span>Escolha um horario de visita</span>
                  <DS
                    selected={crmHorario}
                    onChange={date => setCrmHorario(date)}
                    locale="pt-BR"
                    minDate={new Date()}
                    timeFormat="HH:mm"
                    showTimeSelect
                    placeholderText="Selecionar data"
                    dateFormat="d/MM/yyyy HH:mm"
                    es
                  />
                </Label>
                <Textarea name="obs" label="Observação" />
                {integracao.url_produtos !== null &&
                  !dadosAtendimento.unique_product && (
                    <Select
                      name="imovel_id"
                      labelSelect="Imoveis"
                      options={produtos}
                    />
                  )}
                {(user.time.corretores === '1' && integracao.url_corretores) ||
                  (dadosLead.produto_id === 69 && (
                    <Select
                      name="corretor_id"
                      labelSelect="Corretores"
                      options={corretores}
                    />
                  ))}
                <Button tamanho="40px" load={carregar}>
                  Enviar
                </Button>
              </Form>
            )}
            {visibleEnviarNegociacao && (
              <Form
                ref={enviarNegociacaoRef}
                onSubmit={handleEnviarNegociacao}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                {integracao.url_produtos !== null &&
                  !dadosAtendimento.unique_product && (
                    <Select
                      name="imovel_id"
                      labelSelect="Imoveis"
                      options={produtos}
                    />
                  )}
                {user.time.corretores === '1' && integracao.url_corretores && (
                  <Select
                    name="corretor_id"
                    labelSelect="Corretores"
                    options={corretores}
                  />
                )}
                <Button tamanho="40px" load={carregar}>
                  Enviar
                </Button>
              </Form>
            )}
            {visibleEnviarLead && (
              <Form
                ref={enviarLeadRef}
                onSubmit={handleEnviarLead}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                {integracao.url_produtos !== null &&
                  !dadosAtendimento.unique_product && (
                    <Select
                      name="imovel_id"
                      labelSelect="Imoveis"
                      options={produtos}
                    />
                  )}
                {user.time.corretores === '1' && integracao.url_corretores && (
                  <Select
                    name="corretor_id"
                    labelSelect="Corretores"
                    options={corretores}
                  />
                )}
                <Button tamanho="40px" load={carregar}>
                  Enviar
                </Button>
              </Form>
            )}
            {visibleAgendar && (
              <Form
                ref={agendarRef}
                onSubmit={handleAgendarAtendimento}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                <Label>
                  <span>Escolha um horario de visita</span>
                  <DS
                    selected={crmHorario}
                    onChange={date => setCrmHorario(date)}
                    locale="pt-BR"
                    minDate={new Date()}
                    timeFormat="HH:mm"
                    showTimeSelect
                    placeholderText="Selecionar data"
                    dateFormat="d/MM/yyyy HH:mm"
                    es
                  />
                </Label>

                <Button tamanho="40px" load={carregar}>
                  Agendar
                </Button>
              </Form>
            )}
            {visibleCancelar && (
              <Form
                ref={cancelarRef}
                onSubmit={handleCancelarAtendimento}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                <Select
                  name="cancelamento_id"
                  labelSelect="Motivos de cancelamentos"
                  options={cancelamentos.map(item => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
                <Button tamanho="40px" load={carregar}>
                  Cancelar
                </Button>
              </Form>
            )}
            {visibleEnviarParaEmail && (
              <Form
                ref={emailRef}
                onSubmit={handleEnviarDiretoParaEmail}
                autoComplete="off"
              >
                <Textarea name="obs" label="Observação" />
                <Button tamanho="40px" load={carregar}>
                  Enviar
                </Button>
              </Form>
            )}
          </Card>
        </Wrapper>
      </Container>
      {visibleLigacao && (
        <ReactModal
          initWidth={600}
          initHeight={600}
          isOpen={visibleLigacao}
          top={50}
        >
          <ModalBody>
            <iframe
              src={url}
              frameBorder="0"
              title="ligacao"
              allow="microphone"
              height="500"
            />
          </ModalBody>
          <ModalMenus>
            <button type="button" onClick={() => setVisibleLigacao(false)}>
              Fechar
            </button>
          </ModalMenus>
        </ReactModal>
      )}
    </>
  );
}


